export interface IGTINSearchResult {
  gtin: string;
  description: string | undefined;
  sku: string | undefined;
  brand: string | undefined;
  packagingLevel: string | undefined;
  partyName: string | undefined;
  prefix: string | undefined;
  imageURL: string | undefined;
  certificateFile: string | undefined;
  certificateFileExpiresOn: string | undefined;
  provider: string | undefined;
  queryDate: Date;
}
